import { useState } from 'react';
import { EDITORIAL } from '@/mocks/trending';

const COVERS: Record<string, string> = {
  e1: 'https://readdy.ai/api/search-image?query=vibrant%20editorial%20flat%20illustration%20of%20a%20dramatic%20basketball%20buzzer%20beater%20moment%20on%20a%20court%2C%20dynamic%20cheering%20crowd%20silhouettes%2C%20bold%20coral%20red%20and%20warm%20cream%20palette%2C%20clean%20vector%20graphic%20style%2C%20energetic%20composition%20with%20soft%20shadows&width=1200&height=800&seq=editorial-sport-01&orientation=landscape',
  e2: 'https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20concert%20stage%20with%20crowd%20holding%20glowing%20light%20sticks%20and%20concert%20ticket%20booth%20theme%2C%20warm%20coral%20and%20mustard%20tones%2C%20clean%20minimal%20vector%20graphic%2C%20soft%20shadows%20and%20rounded%20shapes&width=1200&height=800&seq=editorial-concert-02&orientation=landscape',
  e3: 'https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20modern%20smartphone%20surrounded%20by%20floating%20ai%20assistant%20interface%20and%20chat%20bubbles%2C%20warm%20cream%20background%20with%20watermelon%20green%20accents%2C%20clean%20minimal%20vector%20style%2C%20balanced%20composition&width=1200&height=800&seq=editorial-ai-03&orientation=landscape',
};

export default function Editorial() {
  const [openId, setOpenId] = useState('e1');

  return (
    <section id="deep" className="scroll-mt-24 bg-foreground-950 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-500/20 px-3 py-1 text-xs font-semibold text-accent-300 border border-accent-500/40">
              <i className="ri-moon-clear-line" aria-hidden="true"></i>深夜瓜田 · 深度吃瓜
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">
              不止看热闹，<span className="text-accent-400">更看懂门道</span>
            </h2>
            <p className="mt-2 max-w-2xl text-sm md:text-base text-background-100/70">
              编辑团队把热搜话题拆成一条条可复盘的传播路径，帮你搞懂热度为什么涨、又为什么散。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {['传播拆解', '热度复盘', '趋势前瞻'].map((t) => (
              <span
                key={t}
                className="whitespace-nowrap rounded-full border border-background-100/20 bg-background-50/5 px-3 py-1.5 text-xs font-medium text-background-100/80"
              >
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 md:mt-9">
          {EDITORIAL.map((item) => {
            const open = item.id === openId;
            return (
              <article
                key={item.id}
                className={`overflow-hidden rounded-xl border transition ${
                  open ? 'border-accent-500/40 bg-foreground-900/70' : 'border-foreground-700/50 bg-foreground-900/40'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? '' : item.id)}
                  aria-expanded={open}
                  className="flex w-full items-center gap-3 p-4 text-left md:p-5"
                >
                  <span
                    className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-bold ${
                      open ? 'bg-accent-500 text-foreground-950' : 'bg-accent-500/20 text-accent-300'
                    }`}
                  >
                    {item.kicker}
                  </span>
                  <h3 className="flex-1 font-heading text-base font-bold text-background-50 md:text-lg">
                    {item.title}
                  </h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-100/20 text-background-100 transition ${
                      open ? 'rotate-180 bg-accent-500 text-foreground-950' : ''
                    }`}
                    aria-hidden="true"
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>

                {open && (
                  <div className="grid gap-4 border-t border-foreground-700/40 px-4 pb-5 pt-4 md:grid-cols-[0.9fr_1.1fr] md:gap-6 md:px-5">
                    <div className="relative h-40 w-full overflow-hidden rounded-lg md:h-auto">
                      <img
                        src={COVERS[item.id]}
                        alt={`${item.title}专题封面图`}
                        title={`${item.title} · 快瓜深度解读`}
                        className="absolute inset-0 h-full w-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-sm leading-relaxed text-background-100/85">{item.lead}</p>
                      <ul className="mt-3 space-y-2">
                        {item.points.map((p, i) => (
                          <li key={i} className="flex gap-2 text-sm text-background-100/75">
                            <i className="ri-checkbox-circle-fill mt-0.5 shrink-0 text-accent-400" aria-hidden="true"></i>
                            <span>{p}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}